<p>
  {{ 'common.bukTicketPreview.messages.linkTicketDescription' | translate }}
</p>
<table>
  <thead>
    <tr>
      <th></th>
      <th>
        {{ 'common.bukTicketPreview.titles.ticketLink' | translate }}
      </th>
      <th>
        {{ 'common.bukTicketPreview.titles.ticketNumber' | translate }}
      </th>
    </tr>
  </thead>
  <tbody>
    <tr>
      <td>[{{ 'common.bukTicketPreview.titles.example' | translate }}]</td>
      <td>https://buk.io/ticket/0000-0000-0000-0000</td>
      <td>0000-0000-0000-0000</td>
    </tr>
  </tbody>
</table>
<p>
  <mat-icon class="error-icon">error</mat-icon
  >{{ 'common.bukTicketPreview.messages.linkTicketWarning' | translate }}
</p>
